.loading-wrapper {
  position: relative;
  width: 100%;
  .content {
    z-index: 0;
  }
  .spinner {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100;
    text-align: center;
    width: 100%;
    height: 100%;
    padding-top: 10%;
    background-color: rgba($color: #fff, $alpha: 0.5);
  }
}
